module.exports = __webpack_public_path__ + "static/img/2.d36747e3.png";